// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3q9Tr","image":"Header_image__3tCSC","name":"Header_name__2bK8m","info":"Header_info__VSV9a","infoRow":"Header_infoRow__1YkZs"};